// src/components/common/BusyOverlay.tsx
import { useEffect, useState } from 'react';
import { useBusy } from '@/contexts/BusyContext';
import BlueltBrandMark from './BlueltBrandMark';
import './BusyOverlay.css';

// Texto multi-estágio: rotaciona conforme o tempo decorrido (§4.5 do plano).
// Só rotaciona quando showBusy() NÃO recebeu mensagem custom.
const STAGES = [
  { afterMs: 0, text: 'Conectando ao servidor...' },
  { afterMs: 1000, text: 'Processando seus dados...' },
  { afterMs: 3000, text: 'Quase pronto...' },
  { afterMs: 5000, text: 'Operação demorada — aguarde, não feche a janela...' },
] as const;

const BusyOverlay = () => {
  const { isVisible, message } = useBusy();
  const [stageText, setStageText] = useState<string>(STAGES[0].text);

  useEffect(() => {
    // Mensagem custom tem prioridade — não rotaciona.
    if (!isVisible || message) return;
    setStageText(STAGES[0].text);
    const timers = STAGES.map((s) =>
      window.setTimeout(() => setStageText(s.text), s.afterMs)
    );
    return () => timers.forEach((t) => window.clearTimeout(t));
  }, [isVisible, message]);

  if (!isVisible) return null;

  return (
    <div className="busy-overlay" role="alert" aria-busy="true" aria-live="polite">
      <div className="busy-content">
        <div className="busy-logo-container">
          <BlueltBrandMark className="busy-brand-mark" />
        </div>
        <div className="busy-text">{message ?? stageText}</div>
      </div>
    </div>
  );
};

export default BusyOverlay;
